import { render, staticRenderFns } from "./msv2.vue?vue&type=template&id=41430378&scoped=true"
import script from "./msv2.vue?vue&type=script&lang=js"
export * from "./msv2.vue?vue&type=script&lang=js"
import style0 from "./msv2.vue?vue&type=style&index=0&id=41430378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41430378",
  null
  
)

export default component.exports